import React from 'react';
import { Check, X } from 'lucide-react';

const AudienceSection = ({ data }) => {
  return (
    <section className="px-5 sm:px-6 py-14 md:py-20 bg-[#f9fafb]">
      <div className="max-w-4xl mx-auto">
        {/* Intro Line */}
        <p className="text-center text-gray-600 mb-8 text-sm sm:text-base">
          To save time, please note:
        </p>
        
        <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
          {/* This Is For */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_1px_2px_rgba(0,0,0,0.04)] border border-gray-100/80">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-5 flex items-center gap-2">
              <Check className="w-5 h-5 text-[#00c853]" strokeWidth={2.5} />
              {data.forTitle}
            </h3>
            <ul className="space-y-3">
              {data.forList.map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-gray-700">
                  <Check className="w-4 h-4 text-[#00c853] flex-shrink-0" strokeWidth={2} />
                  <span className="text-sm sm:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          
          {/* This Is Not For */}
          <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_1px_2px_rgba(0,0,0,0.04)] border border-gray-100/80">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-5 flex items-center gap-2">
              <X className="w-5 h-5 text-red-500" strokeWidth={2.5} />
              {data.notForTitle}
            </h3>
            <ul className="space-y-3">
              {data.notForList.map((item, index) => (
                <li key={index} className="flex items-center gap-3 text-gray-500">
                  <X className="w-4 h-4 text-red-400 flex-shrink-0" strokeWidth={2} />
                  <span className="text-sm sm:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
